<template>
  <section class="container-lg !pr-0 flex w-full">
    <div
        class="w-full flex flex-col h-max items-center justify-center py-[50px] lg:[100px] px-[20px] sm:px-[20%] lg:px-[25%] xl:px-[30%] ">

      <div class="mb-[20px] text-center">
        <h1 class="section__title  section__title--lg">
          {{ splitTitle(in18['page_create_new_profile'])?.first }}
          <span :class="['text-lime-green ']">
              {{ splitTitle(in18['page_create_new_profile'])?.last }}
          </span>
        </h1>
        <div class="text-[16px] font-light text-medium-gray">
          {{ in18['page_create_new_profile_description'] }}
        </div>
      </div>

      <div class="w-full">
        <form @submit.prevent="submitForm" class="flex flex-col gap-[12px]" autocomplete="off">

          <div class="grid grid-cols-2 gap-4 mb-[8px] mt-[12px] text-center">
            <div class="flex justify-center">
              <div class="radio">
                <input id="user_type_b2c" v-model="user.type" class="radio__input" name="name1" type="radio"
                       value="b2c">
                <label class="radio__label" for="user_type_b2c">{{ in18['attribute_user_physical_person'] }}</label>
              </div>
            </div>
            <div class="flex justify-center">
              <div class="radio">
                <input id="user_type_b2b" v-model="user.type" class="radio__input" name="name1" type="radio"
                       value="b2b">
                <label class="radio__label" for="user_type_b2b">{{ in18['attribute_user_legal_person'] }}</label>
              </div>
            </div>
            <div class="col-span-2 flex justify-center">
              <div class="radio">
                <input id="user_type_b2g" v-model="user.type" class="radio__input" name="name1" type="radio"
                       value="b2g">
                <label class="radio__label" for="user_type_b2g">{{ in18['attribute_user_government_person'] }}</label>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                   :class="[user.name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   for="user_name">
              {{ in18['attribute_user_first_name'] }}
            </label>
            <input
                id="user_name"
                v-model="user.name"
                :class="[errors['user.name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.name && 'pt-[30px]']"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="user_name"
                type="text"
                @input="clearValidationError('user.name')"
                autocomplete="off"
            >
            <validation-error :errors="errors['user.name']"/>
          </div>

          <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                   :class="[user.surname ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   for="user_surname">
              {{ in18['attribute_user_surname'] }}
            </label>
            <input
                id="user_surname"
                v-model="user.surname"
                :class="[errors['user.surname'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.surname && 'pt-[30px]']"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="user_surname"
                type="text"
                @input="clearValidationError('user.surname')"
                autocomplete="off"
            >
            <validation-error :errors="errors['user.surname']"/>
          </div>

          <div class="flex flex-col gap-1 relative">
            <label class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                   :class="[user.email ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   for="user_email">
              {{ in18['attribute_user_email'] }}
            </label>
            <input
                id="user_email"
                v-model="user.email"
                :class="[errors['user.email'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.email && 'pt-[30px]']"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="user_email"
                type="text"
                @input="clearValidationError('user.email')"
                autocomplete="off"
            >
            <validation-error :errors="errors['user.email']"/>
          </div>
          <div class="flex flex-col gap-1 relative overflow-hidden">
            <label class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none"
                   :class="[user.phone.number ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   for="mobile_phone_number">
              {{ in18['attribute_user_phone'] }}
            </label>

            <input
                id="mobile_phone_number"
                v-model="user.phone.number"
                :class="[errors['user.phone.number'] || errors['user.phone.countryCallingCode'] ? 'border-[#eb2635] ' : 'focus-within:border-lime-green border-light-gray/25', user.phone.number ? 'pl-[100px] pt-[30px]' : 'pl-[16px]' ]"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px]   font-light leading-[20px] text-charcoal border rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                name="mobile_phone_number"
                type="number"
                @input="clearValidationError('user.phone.number')"
            >
            <div
                :class="[user.phone.number ? 'top-[23px] left-[16px] opacity-100': 'top-[-4px] left-[-60px] opacity-0 pointer-events-none']"
                class="absolute  text-[16px] font-thin leading-[20px] pr-2 border-r border-l-medium-gray transition-all">

              <span class="prefix">+</span>

              <select v-bind:preventFocusShift="true" class="outline-none bg-opacity-0 w-[60px]"
                      v-model="user.phone.countryCallingCode"
                      @update="clearValidationError('user.phone.countryCallingCode')" name="user_phone_country" id="">
                <option v-for="c in getEUPhoneCountries()" :value="c.countryCallingCode" class="text-[14px]">
                  {{ c.countryCallingCode }}
                </option>
              </select>

            </div>

            <span v-if="phoneErrors?.length" class=" text-[12px] text-[#eb2635]" v-html="phoneErrors?.[0]"></span>
          </div>

          <div class="flex flex-col gap-1 relative">
            <div class="w-full relative">
              <label
                  class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                  :class="[user.password ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                  for="user_password">
                {{ in18['attribute_user_password'] }}
              </label>
              <input
                  id="user_password"
                  v-model="user.password"
                  :class="[errors['user.password'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.password && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="user_password"
                  type="password"
                  @input="clearValidationError('user.password')"
                  autocomplete="new-password"
              >
              <button class="form-control-showhide" data-target="#user_password" type="button">
                {{ in18['attribute_show_hide'] }}
              </button>
            </div>
            <validation-error :errors="errors['user.password']"/>
          </div>

          <div class="flex flex-col gap-1 relative">
            <div class="relative w-full">
              <label
                  class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                  :class="[user.password_confirmation ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                  for="confirm_user_password">
                {{ in18['attribute_user_password_confirmation'] }}
              </label>
              <input
                  id="confirm_user_password"
                  v-model="user.password_confirmation"
                  :class="[errors['user.password_confirmation'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', user.password_confirmation && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="w-full h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="confirm_user_password"
                  type="password"
                  @input="clearValidationError('user.password_confirmation')"
                  autocomplete="new-password"
              >
              <button class="form-control-showhide" data-target="#confirm_user_password" type="button">
                {{ in18['attribute_show_hide'] }}
              </button>
            </div>
            <validation-error :errors="errors['user.password_confirmation']"/>
          </div>

          <template v-if="user.type === 'b2b' || user.type === 'b2g'">

            <div class="flex flex-col gap-1 relative">
              <label
                  class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                  :class="[company.name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                  for="company_name">
                {{ in18['attribute_company_name'] }}
              </label>
              <input
                  id="company_name"
                  v-model="company.name"
                  :class="[errors['company.name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.name && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="company_name"
                  type="text"
                  @input="clearValidationError('company.name')"
              >
              <validation-error :errors="errors['company.name']"/>
            </div>

            <!--  <div class="flex flex-col gap-1 relative">-->
            <!--    <select-->
            <!--        id="company_bank_id"-->
            <!--        v-model="company.bank_id"-->
            <!--        :disabled="inProgress"-->
            <!--        :class="[errors['company.bank_id'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.bank_id === null ? 'text-gray' : '' ]"-->
            <!--        class="appearance-none h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all placeholder-gray"-->
            <!--        name="company_bank_id"-->
            <!--        @input="clearValidationError('company.bank_id')">-->
            <!--      <option :value="null" disabled selected class="text-gray">{{-->
            <!--          in18['attribute_company_bank_option']-->
            <!--        }}-->
            <!--      </option>-->
            <!--      <option v-for="bank in banks" :key="bank.id" :value="bank.id">-->
            <!--        {{ bank.name }}-->
            <!--      </option>-->
            <!--    </select>-->
            <!--    <span-->
            <!--        class="pointer-events-none absolute inset-y-0 right-[16px] flex items-center"-->
            <!--    >-->
            <!--      <img-->
            <!--          alt=""-->
            <!--          src="/shop/images/dropdown-toggle-arrow.svg"-->
            <!--          class="h-5 w-5 text-gray-400 transform-all  duration-300"-->
            <!--          aria-hidden="true"-->
            <!--      />-->
            <!--    </span>-->
            <!--  </div>-->
            <!--  <validation-error :errors="errors['company.bank_id']"/>-->
            <!--  <div class="flex flex-col gap-1 relative">-->
            <!--    <label-->
            <!--        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"-->
            <!--        :class="[company.acc_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"-->
            <!--        for="company_acc_num">-->
            <!--      {{ in18['attribute_company_account_number'] }}-->
            <!--    </label>-->
            <!--    <input-->
            <!--        id="company_acc_num"-->
            <!--        v-model="company.acc_num"-->
            <!--        :class="[errors['company.acc_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.acc_num && 'pt-[30px]' ]"-->
            <!--        :disabled="inProgress"-->
            <!--        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"-->
            <!--        name="company_acc_num"-->
            <!--        type="text"-->
            <!--        @input="clearValidationError('company.acc_num')"-->
            <!--    >-->
            <!--    <validation-error :errors="errors['company.acc_num']"/>-->
            <!--  </div>-->

            <div class="flex flex-col gap-1 relative">
              <label
                  class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                  :class="[company.reg_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                  for="company_reg_num">
                {{ in18['attribute_company_reg_number'] }}
              </label>
              <input
                  id="company_reg_num"
                  v-model="company.reg_num"
                  :class="[errors['company.reg_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.reg_num && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="company_reg_num"
                  type="text"
                  @input="clearValidationError('company.reg_num')"
              >
              <validation-error :errors="errors['company.reg_num']"/>
            </div>

            <div class="flex flex-col gap-1 relative">
              <label
                  class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                  :class="[company.vat_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                  for="company_vat_num">
                {{ in18['attribute_company_tax_number'] }}
              </label>
              <input
                  id="company_vat_num"
                  v-model="company.vat_num"
                  :class="[errors['company.vat_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.vat_num && 'pt-[30px]' ]"
                  :disabled="inProgress"
                  class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                  name="company_vat_num"
                  type="text"
                  @input="clearValidationError('company.vat_num')"
              >
              <validation-error :errors="errors['company.vat_num']"/>
            </div>

            <!--  <div class="flex flex-col gap-1 relative">-->
            <!--    <label-->
            <!--        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"-->
            <!--        :class="[company.address ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"-->
            <!--        for="company_address">-->
            <!--      {{ in18['attribute_company_address'] }}-->
            <!--    </label>-->
            <!--    <input-->
            <!--        id="company_address"-->
            <!--        v-model="company.address"-->
            <!--        :class="[errors['company.address'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.address && 'pt-[30px]' ]"-->
            <!--        :disabled="inProgress"-->
            <!--        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"-->
            <!--        name="company_address"-->
            <!--        type="text"-->
            <!--        @input="clearValidationError('company.address')"-->
            <!--    >-->
            <!--    <validation-error :errors="errors['company.address']"/>-->
            <!--  </div>-->

            <!--  <div class="flex flex-col gap-1 relative">-->
            <!--    <label-->
            <!--        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"-->
            <!--        :class="[company.city ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"-->
            <!--        for="company_city">-->
            <!--      {{ in18['attribute_company_city'] }}-->
            <!--    </label>-->
            <!--    <input-->
            <!--        id="company_city"-->
            <!--        v-model="company.city"-->
            <!--        :class="[errors['company.city'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.city && 'pt-[30px]' ]"-->
            <!--        :disabled="inProgress"-->
            <!--        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"-->
            <!--        name="company_city"-->
            <!--        type="text"-->
            <!--        @input="clearValidationError('company.city')"-->
            <!--    >-->
            <!--    <validation-error :errors="errors['company.city']"/>-->
            <!--  </div>-->

            <!--  <div class="flex flex-col gap-1 relative">-->
            <!--    <label-->
            <!--        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"-->
            <!--        :class="[company.zip ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"-->
            <!--        for="company.zip">-->
            <!--      {{ in18['attribute_company_zip'] }}-->
            <!--    </label>-->
            <!--    <input-->
            <!--        id="company.zip"-->
            <!--        v-model="company.zip"-->
            <!--        :class="[errors['company.zip'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', company.zip && 'pt-[30px]' ]"-->
            <!--        :disabled="inProgress"-->
            <!--        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"-->
            <!--        name="company.zip"-->
            <!--        type="text"-->
            <!--        @input="clearValidationError('company.zip')"-->
            <!--    >-->
            <!--    <validation-error :errors="errors['company.zip']"/>-->
            <!--  </div>-->

            <address-form
                v-show="horizon.physical_address_exists === false"
                :in18="in18"
                :address="physical_address"
                :errors="errors"
                :countries="countries.value"
                :prefix="'physical_address'"
                :in_progress="inProgress"
                :clear-validation-error="clearValidationError"
            />

            <address-form
                v-show="horizon.legal_address_exists === false"
                :in18="in18"
                :address="legal_address"
                :errors="errors"
                :countries="countries.value"
                :prefix="'legal_address'"
                :in_progress="inProgress"
                :clear-validation-error="clearValidationError"
            />

          </template>

          <validation-error :errors="errors['g-recaptcha-response']"/>

          <div class="">
            <div class="checkbox">
              <input id="terms_subscription" v-model="terms.subscription" class="checkbox__input"
                     name="terms_subscription" type="checkbox" @input="clearValidationError('terms.subscription')">
              <label class="checkbox__label" for="terms_subscription">
                {{ in18['page_subscribe_agree_label'] }}
                <validation-error :errors="errors['terms.subscription']"/>
              </label>
            </div>
          </div>

          <div class="mb-[16px]">
            <div class="checkbox">
              <input id="terms_privacy" v-model="terms.privacy" class="checkbox__input" name="terms_privacy"
                     type="checkbox" @input="clearValidationError('terms.privacy')">
              <label class="checkbox__label" for="terms_privacy">
                <div v-html="terms_links"/>
              </label>
            </div>
            <validation-error :errors="errors['terms.privacy']"/>
          </div>

          <google-recaptcha-v3
              id="register_us_id"
              ref="captcha"
              v-model="terms.gRecaptchaResponse"
              :site-key="captcha_site_key"
              action="register_action"
              corner
          />

          <button :disabled="inProgress" class="btn  btn--green  btn--md  btn--block" type="submit">
            {{ in18['page_create_new_profile'] }}
          </button>
        </form>
        <div class="mt-[12px] text-center text-[14px]">
          {{ in18['page_already_have_a_profile'] }}
          <a :href="login_route" :title="in18['page_sign_in']" class="link  link--primary">
            <b>{{ in18['page_sign_in'] }}</b>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section class="section hidden">
    <div class="container-xl">
      <div class="auth">
        <div class="section__header  text-center">
          <h1 class="section__title  section__title--lg">
            {{ in18['page_create_new_profile'] }}
          </h1>
          <div class="section__text">
            {{ in18['page_create_new_profile_description'] }} 👋
          </div>
        </div>
        <div class="auth__footer">
          {{ in18['page_already_have_a_profile'] }}
          <a :href="login_route" :title="in18['page_sign_in']" class="link  link--primary">
            <b>{{ in18['page_sign_in'] }}</b>
          </a>
        </div>
      </div>
    </div><!-- /.container -->
  </section><!-- /.section -->
</template>

<script setup>
import {ref, reactive, computed, onMounted} from 'vue';
import axios from 'axios';
import AddressForm from '../components/register/AddressForm.vue';
import ValidationError from '../features/ValidationError.vue';
import { getEUPhoneCountries } from '../helpers/phone-countries';

// Define Props
const props = defineProps({
  in18:             {
    type: Object,
  },
  captcha_site_key: {
    type: String,
  },
  terms_links:      {
    type: String,
  },
  login_route:      {
    type: String,
  },
});

// Reactive Data
const inProgress = ref(false);
const same_address = ref(false);

const user = reactive({
  type:                  'b2c',
  country_id:            112,
  name:                  '',
  surname:               '',
  email:                 '',
  password:              '',
  password_confirmation: '',
  phone:                 {
    number:             '',
    countryCallingCode: 371,
  },
});

const company = reactive({
  bank_id:    null,
  country_id: 122,
  name:       '',
  vat_num:    '',
  reg_num:    '',
  acc_num:    '',
  city:       '',
  zip:        '',
  address:    '',
});

const terms = reactive({
  subscription:       0,
  privacy:            0,
  gRecaptchaResponse: null,
});

const legal_address = reactive({
  country_id: 112,
  city:       '',
  region:     '',
  address:    '',
  zip:        '',
});

const physical_address = reactive({
  country_id: 112,
  city:       '',
  region:     '',
  address:    '',
  zip:        '',
});

const banks = ref({});
const errors = reactive({});
const countries = reactive({});
const recaptchaLoaded = ref(false);
const horizon = ref({
  'contact_person_exists':   false,
  'customer_exists':         false,
  'legal_address_exists':    true,
  'physical_address_exists': true,
});

// Computed Properties
const phoneErrors = computed(() => {
  let errorsArray = [];
  if (errors['user.phone.number']) {
    errorsArray = errorsArray.concat(errors['user.phone.number']);
  }
  if (errors['user.phone.countryCallingCode']) {
    errorsArray = errorsArray.concat(errors['user.phone.countryCallingCode']);
  }
  return errorsArray;
});

// Refs
const captcha = ref(null);

// Methods
function splitTitle(string) {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
}

function initRecaptcha() {
  if (!recaptchaLoaded.value) {
    captcha.value.init();
    recaptchaLoaded.value = true;
  }
}

function clearValidationError(fieldName) {
  if (errors[fieldName]) {
    errors[fieldName] = null;
  }
}

function submitForm() {
  if (inProgress.value) {
    return;
  }

  inProgress.value = true;

  const data = {
    user:             user,
    terms:            terms,
    company:          company,
    legal_address:    legal_address,
    physical_address: physical_address,
    same_address:     same_address.value,
  };

  axios
      .post('/register', data)
      .then((response) => {
        window.toastr.success(response.data.message);
        window.location.href = response.data.path;
        captcha.value.execute();
      })
      .catch((error) => {
        inProgress.value = false;
        window.toastr.error(error.response.data.message);
        horizon.value = error.response.data.errors.horizon;
        Object.assign(errors, error.response.data.errors);
        captcha.value.execute();
        window.scrollToErrorMessage();
      })
      .finally(() => {
        inProgress.value = false;
        captcha.value.execute();
      });
}

// Lifecycle Hooks
onMounted(() => {
  initRecaptcha();
  // axios.get('/api/banks').then((response) => {
  //  banks.value = response.data.banks;
  // });
  axios.get('/api/countries').then((response) => {
    countries.value = response.data.countries;
  });
});
</script>